import { ReactElement, useEffect, useRef } from "react";
import { Card, CardContent, CardHeader } from "@mui/material";
import ItemValue from "./itemValue";
import { IComponentProps } from "./types";
import Header from "./header";
// import { styled } from "@mui/material/styles";
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';

//
// const getColor = (status: number) => {
//   switch (status) {
//     case 1:
//       return "green";
//     case 2:
//       return "yellow";
//     case 3:
//       return "red";
//     default:
//       return "gray";
//   }
// };

// const Rectangle = styled("div", {
//   shouldForwardProp: (prop) => prop !== "status"
// })<{ status: number, }>(({ status }) => ({
//   justifySelf: "center",
//   width: 20,
//   height: 20,
//   margin: "4px 0px",
//   background: getColor(status),
//   border: "1px solid #666a6e !important",
//   borderRadius: 5
// }));


const StatusComponent = ({ status }: { status: number }) => {

  if (status === 1) {
    return <CheckIcon style={{ color: "green" }} />;
  }

  if (status === 2) {
    return <ReportProblemIcon style={{ color: "yellow" }} />;
  }

  if (status === 3) {
    return <ClearIcon style={{ color: "red" }} />;
  }

  return <HelpCenterIcon style={{ color: "gray" }} />;
}

const CasterComponent = ({ realtime, overviewData, updateOverview, firstTime }: IComponentProps): ReactElement => {
  const heatNumber = useRef<any>(null);
  const actualHeatNumber = realtime["MS.CASTER1.N2.ACTUAL_HEAT_NUMBER_LS"];

  useEffect(() => {
    if (actualHeatNumber && actualHeatNumber.Value !== heatNumber.current) {
      if (heatNumber.current !== null && !firstTime) {
        updateOverview("CASTER");
      }

      heatNumber.current = actualHeatNumber.Value;
    }
  }, [actualHeatNumber]);

  return (
    <Card style={{ background: "rgba(0, 0, 0, .3)" }}>
      <CardHeader className="p-1" title="CASTER" style={{ background: "rgba(82,99,108, 1)" }} />
      <CardContent className="p-0">
        <Header overviewData={overviewData} />

        <div className="display-grid gap-1 p-1" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr" }}>
          <div className="display-grid justify-content-start align-content-center">
            <strong>GENERAL</strong>
          </div>
          <ItemValue title="Super Heat" value={realtime["MS.CASTER1.AUTO_SUPER_HEAT"]?.Value} color="green"/>
          <ItemValue title="A1.GROSS_WEIGHT" value={realtime["MS.CASTER1.TURRET.A1.GROSS_WEIGHT"]?.Value} color="green"/>
          <ItemValue title="A2.GROSS_WEIGHT" value={realtime["MS.CASTER1.TURRET.A2.GROSS_WEIGHT"]?.Value} color="green"/>
          <div />
          <div />

          <div className="display-grid justify-content-start align-content-center">
            <strong>STATUS</strong>
          </div>
          <ItemValue title="STR01" value={<StatusComponent status={realtime["MS.CASTER1.N2.STR01.RUN_STATUS"]?.Value as number ?? 0}/>} color=""/>
          <ItemValue title="STR02" value={<StatusComponent status={realtime["MS.CASTER1.N2.STR02.RUN_STATUS"]?.Value as number ?? 0}/>} color=""/>
          <ItemValue title="STR03" value={<StatusComponent status={realtime["MS.CASTER1.N2.STR03.RUN_STATUS"]?.Value as number ?? 0}/>} color=""/>
          <ItemValue title="STR04" value={<StatusComponent status={realtime["MS.CASTER1.N2.STR04.RUN_STATUS"]?.Value as number ?? 0}/>} color=""/>
          <ItemValue title="STR05" value={<StatusComponent status={realtime["MS.CASTER1.N2.STR05.RUN_STATUS"]?.Value as number ?? 0}/>} color=""/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>MOULD LEVEL</strong>
          </div>
          <ItemValue title="STR01" value={realtime["MS.CASTER1.MOULD.LEVEL.STR01.ACTUAL"]?.Value} color="green"/>
          <ItemValue title="STR02" value={realtime["MS.CASTER1.MOULD.LEVEL.STR02.ACTUAL"]?.Value} color="green"/>
          <ItemValue title="STR03" value={realtime["MS.CASTER1.MOULD.LEVEL.STR03.ACTUAL"]?.Value} color="green"/>
          <ItemValue title="STR04" value={realtime["MS.CASTER1.MOULD.LEVEL.STR04.ACTUAL"]?.Value} color="green"/>
          <ItemValue title="STR05" value={realtime["MS.CASTER1.MOULD.LEVEL.STR05.ACTUAL"]?.Value} color="green"/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>MOULD SPEED</strong>
          </div>
          <ItemValue title="STR01" value={realtime["MS.CASTER1.MOULD.LEVEL.STR01.SPEED_ACTUAL"]?.Value} color="green"/>
          <ItemValue title="STR02" value={realtime["MS.CASTER1.MOULD.LEVEL.STR02.SPEED_ACTUAL"]?.Value} color="green"/>
          <ItemValue title="STR03" value={realtime["MS.CASTER1.MOULD.LEVEL.STR03.SPEED_ACTUAL"]?.Value} color="green"/>
          <ItemValue title="STR04" value={realtime["MS.CASTER1.MOULD.LEVEL.STR04.SPEED_ACTUAL"]?.Value} color="green"/>
          <ItemValue title="STR05" value={realtime["MS.CASTER1.MOULD.LEVEL.STR05.SPEED_ACTUAL"]?.Value} color="green"/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>SWV</strong>
          </div>
          <ItemValue title="STR01" value={realtime["MS.CASTER1.N2.STR01.SWV_CALCULATION"]?.Value} color="green"/>
          <ItemValue title="STR02" value={realtime["MS.CASTER1.N2.STR02.SWV_CALCULATION"]?.Value} color="green"/>
          <ItemValue title="STR03" value={realtime["MS.CASTER1.N2.STR03.SWV_CALCULATION"]?.Value} color="green"/>
          <ItemValue title="STR04" value={realtime["MS.CASTER1.N2.STR04.SWV_CALCULATION"]?.Value} color="green"/>
          <ItemValue title="STR05" value={realtime["MS.CASTER1.N2.STR05.SWV_CALCULATION"]?.Value} color="green"/>


          <div className="display-grid justify-content-start align-content-center">
            <strong>FEMS CURRENT</strong>
          </div>
          <ItemValue title="STR01" value={realtime["MS.CASTER1.FEMS.STR01.ACTUAL_CURRENT"]?.Value} color="green"/>
          <ItemValue title="STR02" value={realtime["MS.CASTER1.FEMS.STR02.ACTUAL_CURRENT"]?.Value} color="green"/>
          <ItemValue title="STR03" value={realtime["MS.CASTER1.FEMS.STR03.ACTUAL_CURRENT"]?.Value} color="green"/>
          <ItemValue title="STR04" value={realtime["MS.CASTER1.FEMS.STR04.ACTUAL_CURRENT"]?.Value} color="green"/>
          <ItemValue title="STR05" value={realtime["MS.CASTER1.FEMS.STR05.ACTUAL_CURRENT"]?.Value} color="green"/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>FEMS FLOW</strong>
          </div>
          <ItemValue title="STR01" value={realtime["MS.CASTER1.FEMS.STR01.ACTUAL_FLOW"]?.Value} color="green"/>
          <ItemValue title="STR02" value={realtime["MS.CASTER1.FEMS.STR02.ACTUAL_FLOW"]?.Value} color="green"/>
          <ItemValue title="STR03" value={realtime["MS.CASTER1.FEMS.STR03.ACTUAL_FLOW"]?.Value} color="green"/>
          <ItemValue title="STR04" value={realtime["MS.CASTER1.FEMS.STR04.ACTUAL_FLOW"]?.Value} color="green"/>
          <ItemValue title="STR05" value={realtime["MS.CASTER1.FEMS.STR05.ACTUAL_FLOW"]?.Value} color="green"/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>FEMS FRECUENCY</strong>
          </div>
          <ItemValue title="STR01" value={realtime["MS.CASTER1.FEMS.STR01.ACTUAL_FRECUENCY"]?.Value} color="green"/>
          <ItemValue title="STR02" value={realtime["MS.CASTER1.FEMS.STR02.ACTUAL_FRECUENCY"]?.Value} color="green"/>
          <ItemValue title="STR03" value={realtime["MS.CASTER1.FEMS.STR03.ACTUAL_FRECUENCY"]?.Value} color="green"/>
          <ItemValue title="STR04" value={realtime["MS.CASTER1.FEMS.STR04.ACTUAL_FRECUENCY"]?.Value} color="green"/>
          <ItemValue title="STR05" value={realtime["MS.CASTER1.FEMS.STR05.ACTUAL_FRECUENCY"]?.Value} color="green"/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>MEMS CURRENT</strong>
          </div>
          <ItemValue title="STR01" value={realtime["MS.CASTER1.MEMS.STR01.ACTUAL_CURRENT"]?.Value} color="green"/>
          <ItemValue title="STR02" value={realtime["MS.CASTER1.MEMS.STR02.ACTUAL_CURRENT"]?.Value} color="green"/>
          <ItemValue title="STR03" value={realtime["MS.CASTER1.MEMS.STR03.ACTUAL_CURRENT"]?.Value} color="green"/>
          <ItemValue title="STR04" value={realtime["MS.CASTER1.MEMS.STR04.ACTUAL_CURRENT"]?.Value} color="green"/>
          <ItemValue title="STR05" value={realtime["MS.CASTER1.MEMS.STR05.ACTUAL_CURRENT"]?.Value} color="green"/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>MEMS FLOW</strong>
          </div>
          <ItemValue title="STR01" value={realtime["MS.CASTER1.MEMS.STR01.ACTUAL_FLOW"]?.Value} color="green"/>
          <ItemValue title="STR02" value={realtime["MS.CASTER1.MEMS.STR02.ACTUAL_FLOW"]?.Value} color="green"/>
          <ItemValue title="STR03" value={realtime["MS.CASTER1.MEMS.STR03.ACTUAL_FLOW"]?.Value} color="green"/>
          <ItemValue title="STR04" value={realtime["MS.CASTER1.MEMS.STR04.ACTUAL_FLOW"]?.Value} color="green"/>
          <ItemValue title="STR05" value={realtime["MS.CASTER1.MEMS.STR05.ACTUAL_FLOW"]?.Value} color="green"/>

          <div className="display-grid justify-content-start align-content-center">
            <strong>MEMS FRECUENCY</strong>
          </div>
          <ItemValue title="STR01" value={realtime["MS.CASTER1.MEMS.STR01.ACTUAL_FRECUENCY"]?.Value} color="green"/>
          <ItemValue title="STR02" value={realtime["MS.CASTER1.MEMS.STR02.ACTUAL_FRECUENCY"]?.Value} color="green"/>
          <ItemValue title="STR03" value={realtime["MS.CASTER1.MEMS.STR03.ACTUAL_FRECUENCY"]?.Value} color="green"/>
          <ItemValue title="STR04" value={realtime["MS.CASTER1.MEMS.STR04.ACTUAL_FRECUENCY"]?.Value} color="green"/>
          <ItemValue title="STR05" value={realtime["MS.CASTER1.MEMS.STR05.ACTUAL_FRECUENCY"]?.Value} color="green"/>
        </div>
      </CardContent>
    </Card>
  );
};

export default CasterComponent;